import CustomChip from "../../../../../components/CustomChip";
import {colors} from "../../../../../enums/colors";
import {USER_ACCESS_KEY_MODEL} from "../../../../../enums/userTypeEnum";
import React from "react";
import {useTranslation} from "react-i18next";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

const GeofenceUserScope = ({ geofence}) => {
    const {t} = useTranslation();

    const getUserScopeChip = (trans) => {

        return   <CustomChip
            background={colors.secondary100}
            fontColor={colors.secondary700}
            borderColor={colors.secondary150}
            legend={t(trans)}
            variant='compact'
        />
    }

    return (
        <>
            {(geofence?.applyEmployee || !geofence?.applyContractor || !geofence?.applySupplier) &&
            <div className='d-flex flex-wrap gap-2'>
                {geofence?.applyEmployee && getUserScopeChip(USER_ACCESS_KEY_MODEL.EMPLOYEE)}
                {geofence?.applyContractor && getUserScopeChip(USER_ACCESS_KEY_MODEL.CONTRACTOR)}
                {geofence?.applySupplier && getUserScopeChip(USER_ACCESS_KEY_MODEL.SUPPLIER)}
            </div>
            }
        </>
    );
};
export default GeofenceUserScope;
